module.exports = __webpack_public_path__ + "img/inventions_banner.e574d778.jpg";